import AxiosConfig from '../utils/AxiosConfig';

class BranchService {
  // Obtener todas las sucursales
  async getBranches() {
    try {
      const response = await AxiosConfig.get('/branches');
      return response.data;
    } catch (error) {
      console.error('Error fetching branches:', error);
      throw error;
    }
  }

  // Obtener sucursal por ID
  async getBranchById(branchId) {
    try {
      const response = await AxiosConfig.get(`/branches/${branchId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching branch:', error);
      throw error;
    }
  }

  // Crear nueva sucursal
  async createBranch(branchData) {
    try {
      const response = await AxiosConfig.post('/branches', branchData);
      return response.data;
    } catch (error) {
      console.error('Error creating branch:', error);
      throw error;
    }
  }

  // Actualizar sucursal
  async updateBranch(branchId, branchData) {
    try {
      const response = await AxiosConfig.put(`/branches/${branchId}`, branchData);
      return response.data;
    } catch (error) {
      console.error('Error updating branch:', error);
      throw error;
    }
  }

  // Eliminar sucursal
  async deleteBranch(branchId) {
    try {
      const response = await AxiosConfig.delete(`/branches/${branchId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting branch:', error);
      throw error;
    }
  }
}

export default new BranchService();
